import { render } from "./ConversationCard.vue?vue&type=template&id=21943cb4&scoped=true&ts=true"
import script from "./ConversationCard.vue?vue&type=script&lang=ts"
export * from "./ConversationCard.vue?vue&type=script&lang=ts"

import "./ConversationCard.vue?vue&type=style&index=0&id=21943cb4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21943cb4"]])

export default __exports__